import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <header className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20Korean%20manga%20comic%20panels%20collage%20style%20warm%20terracotta%20and%20cream%20tones%20with%20soft%20watercolor%20brush%20strokes%20flowing%20composition%20elegant%20artistic%20background%20for%20manga%20reading%20website&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩国漫画网 - 韩漫在线观看"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-7xl mx-auto">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h1 className="font-heading text-4xl md:text-6xl font-black text-white leading-tight mb-4">
              韩漫在线观看
            </h1>
            <p className="text-white/80 text-base md:text-lg mb-8 max-w-md mx-auto lg:mx-0">
              漫画免费下拉式阅读模式，畅览好看的韩国漫画全集
            </p>
            <Link
              to="/category/love"
              className="inline-flex items-center gap-2 bg-primary-500 text-white px-7 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              开始阅读
              <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center" />
            </Link>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manga%20art%20compilation%20collage%20featuring%20romantic%20fantasy%20and%20action%20scenes%20soft%20warm%20tones%20elegant%20illustration%20style%20artistic%20manga%20covers%20compilation%20clean%20professional%20layout&width=1200&height=600&seq=hero-art-2026&orientation=landscape"
                alt="好看的韩国漫画全集推荐"
                className="w-full h-auto object-cover"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}